import React from "react";
import Particles from "../Particles/Particles";
import ExecutiveMessage from "./Components/ExecutiveMessage";
import OurServices from "./Components/OurServices";
import DestinationImages from "./Components/DestinationImages";
import TestPreparations from "./Components/TestPreparations";
const Homepage = () => {
  return (
    <>
      <Particles
        title="Empowering Your Journey to International Academic Success"
        subTitle="Strategic Support to Navigate Admissions, Adaptation, and Achievement Worldwide"
        page="homepage"
      />
      <ExecutiveMessage />
      <OurServices />
      <DestinationImages />
      <TestPreparations />
    </>
  );
};

export default Homepage;
